export const CAPTURES_TYPES = {
  CLEAR_CAPTURES: "CLEAR_CAPTURES",
  SET_CAPTURES: "SET_CAPTURES",
  SET_ROUTE_CYCLES: "SET_ROUTE_CYCLES",
  SET_SELECTED_ROUTE_CYCLE: "SET_SELECTED_ROUTE_CYCLE",
  SET_CANCEL_MOTIVES: "SET_CANCEL_MOTIVES",
  HANDLE_CAPTURES_INPUTS: "HANDLE_CAPTURES_INPUTS",
  // new route
  NEW_CAPTURE: "NEW_CAPTURE",
  SEND_NEW_CAPTURE: "SEND_NEW_CAPTURE",
  SET_NEW_CAPTURE: "SET_NEW_CAPTURE",

  EDIT_CAPTURE: "EDIT_CAPTURE",
  SET_EDITED_CAPTURE: "SET_EDITED_CAPTURE",
  DELETE_CAPTURE: "DELETE_CAPTURE"
};
